/* ============================================================
   SignageWorks — temporary landing page behaviour
   ============================================================
   Two jobs: the $100 email capture, and carrying attribution
   through to the Budget Planner so a lead that starts here is
   still attributable when it converts two clicks later.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-sw-landing]');
  if (!root) return;

  var ENDPOINT = root.getAttribute('data-endpoint') || '/api/landing-signup';
  var PLANNER = root.getAttribute('data-planner') || '/pages/2027-signage-budget';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  /**
   * Attribution for this visit. UTMs are read from the query string and
   * cached in sessionStorage, so a visitor who lands with campaign tags and
   * then clicks through to the planner still carries them — the planner is a
   * separate page load and would otherwise see a bare URL.
   */
  function attribution() {
    var params = new URLSearchParams(window.location.search);
    var out = {};
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) {
        out[k] = v;
        try { sessionStorage.setItem('sw_' + k, v); } catch (e) { /* private mode */ }
      } else {
        try {
          var stored = sessionStorage.getItem('sw_' + k);
          if (stored) out[k] = stored;
        } catch (e) { /* private mode */ }
      }
    });
    out.landing_url = window.location.href.slice(0, 500);
    out.referring_url = (document.referrer || '').slice(0, 500);
    return out;
  }

  /** Append the cached UTMs to the planner link so attribution survives the hop. */
  function decorateBudgetCta() {
    var cta = root.querySelector('[data-budget-cta]');
    if (!cta) return;
    var attrib = attribution();
    var url;
    try {
      url = new URL(cta.getAttribute('href'), window.location.origin);
    } catch (e) {
      return;
    }
    UTM_KEYS.forEach(function (k) { if (attrib[k]) url.searchParams.set(k, attrib[k]); });
    cta.setAttribute('href', url.pathname + url.search + url.hash);

    cta.addEventListener('click', function () { track('budget_cta_clicked', {}); });
  }

  /** Shopify analytics if present, console otherwise. Never throws. */
  function track(event, payload) {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib && window.ShopifyAnalytics.lib.track) {
        window.ShopifyAnalytics.lib.track(event, payload || {});
        return;
      }
      if (typeof window.dataLayer !== 'undefined' && window.dataLayer.push) {
        window.dataLayer.push(Object.assign({ event: event }, payload || {}));
        return;
      }
    } catch (e) { /* analytics must never break the page */ }
    if (window.console && console.debug) console.debug('[sw-landing]', event, payload || {});
  }

  /* ---------- $100 email capture ---------- */
  var form = root.querySelector('[data-signup-form]');
  var msg = root.querySelector('[data-signup-msg]');
  var submit = root.querySelector('[data-signup-submit]');
  var input = form ? form.querySelector('input[type=email]') : null;
  var started = false;

  function say(text, kind) {
    if (!msg) return;
    msg.textContent = text;
    msg.className = 'sw-lp__formMsg is-shown ' + (kind === 'ok' ? 'is-ok' : 'is-err');
  }

  if (input) {
    input.addEventListener('input', function () {
      input.classList.remove('is-invalid');
      if (!started && input.value.trim()) { started = true; track('email_form_started', {}); }
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!input) return;

      var email = input.value.trim();
      /* Same rule as EMAIL_RE in sw-planner.js and normalizeEmail() in
         the backend's lead-guard.js. Change all three together. */
      if (!/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(email)) {
        input.classList.add('is-invalid');
        input.focus();
        say('That email address does not look quite right. Mind checking it?', 'err');
        track('form_error', { form: 'landing_signup', reason: 'invalid_email' });
        return;
      }

      var hp = form.querySelector('input[name=company_website]');
      var payload = Object.assign({
        email: email,
        company_website: hp ? hp.value : ''
      }, attribution());

      submit.disabled = true;
      var original = submit.innerHTML;
      submit.textContent = 'Sending…';
      if (msg) msg.className = 'sw-lp__formMsg';

      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; })
            .then(function (body) { return { ok: res.ok, body: body }; });
        })
        .then(function (r) {
          if (!r.ok || !r.body.ok) throw new Error((r.body && r.body.error) || 'Request failed');
          form.reset();
          say(r.body.message || "You're on the list — your $100 credit is on its way.", 'ok');
          track('email_form_completed', {});
        })
        .catch(function (err) {
          if (window.console) console.error('[sw-landing]', err);
          say("We couldn't sign you up just now. Please try again, or email hello@signageworks.com.", 'err');
          track('form_error', { form: 'landing_signup', reason: 'request_failed' });
        })
        .then(function () {
          submit.disabled = false;
          submit.innerHTML = original;
        });
    });
  }

  decorateBudgetCta();
  track('landing_page_viewed', {});
})();
